import $ from 'jquery';
import storeStockList from '../b2b/store-stock-list';

// - js-b2c-store-stock - when not logged in
// - js-b2b-store-stock - when logged in as b2b on standard platform
// - js-atp-store-stock - when logged in as franchise on reseller platform
const selectors = ['.js-atp-store-stock', '.js-b2b-store-stock', '.js-b2c-store-stock'];

const errorTpl = (stockErrorMessage) => `
<ul class="product-variants-card-stock">
    <li class="product-variants-card-stock-item">
        <span class="product-variants-card-stock-status product-variants-card-stock-status-yellow">
            <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg>
        </span>
        <span class="product-variants-card-stock-text"><b>${stockErrorMessage}</b></span>
    </li>
</ul>
`;
const spinner = '<div class="spinner-border"></div>';

function selectorLoop(){
    const $elm = $(this);

    if (!$elm.length) {
        return;
    }

    $elm.each((_, storeStockItem) => {
        const storeStockItemAttr = $(storeStockItem).data();
        if (!storeStockItemAttr.stockUrl || !storeStockItemAttr.variantCode) return;
        // there are cases where products of some color have multiple packagings
        $.get(`${storeStockItemAttr.stockUrl}?code=${storeStockItemAttr.variantCode}`).then((res) => {
            if ($(res).has('product-variants-card-stock-item')) {
                $(storeStockItem).html(res);
                storeStockList.init($(storeStockItem));
            } else {
                $(storeStockItem).html(errorTpl(storeStockItemAttr.stockErrorMessage));
            }
        }).catch(() => {
            $(storeStockItem).html(errorTpl(storeStockItemAttr.stockErrorMessage));
        });
    });
}

function selectorLoopRefresh(selector, variantCode) {
    const $elm = $(selector);

    if (!$elm.length) {
        return;
    }

    const errorMessage = $elm.data().stockErrorMessage;
    const stockUrl = $elm.attr('data-stock-url');

    $elm.html(spinner);

    $.get(`${stockUrl}?code=${variantCode}`).then((res) => {
        if ($(res).has('product-variants-card-stock-item')) {
            $elm.html(res);
            storeStockList.init($elm);
        } else {
            $elm.html(errorTpl(errorMessage));
        }
    }).catch(() => {
        $elm.html(errorTpl(errorMessage));
    });
}

function init() {
    $(selectors).each(selectorLoop);
}

function refreshVariant(variantCode) {
    $(selectors).each((_, selector) => selectorLoopRefresh(selector, variantCode));
}

export default {
    init: init,
    refreshVariant: refreshVariant
};
